import { Component, Input, OnInit, AfterViewInit, OnChanges } from '@angular/core';
import { PaymentMethodService } from 'src/_lib/service/payment-method.service';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-affirm-widget',
  templateUrl: './affirm-widget.component.html',
  styleUrls: ['./affirm-widget.component.scss'],
  standalone: true
})
export class AffirmWidgetComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() amount!: number;
  scriptLoaded = false;
  cartSettings: any;

  constructor(
    private paymentMethodService: PaymentMethodService,
    private browser: BrowserService
  ) { }

  ngOnInit() {
    this.getCartSettings();
  }

  ngAfterViewInit() {
    this.render();
  }

  ngOnChanges() {
    this.render();
  }

  getCartSettings(): void {
    this.paymentMethodService.paymentService().subscribe({
      next: (response) => {
        this.cartSettings = response[0]?.data;
        this.loadScript();
      },
      error: (err) => {
        console.error('Cart setting error:', err);
      }
    });
  }

  loadScript(): Promise<void> {
    return new Promise((resolve) => {
      if (!this.browser.isBrowser) { resolve(); return; }
      if (this.scriptLoaded || document.getElementById('affirm-script')) {
        this.scriptLoaded = true;
        resolve();
        return;
      }
      (window as any)._affirm_config = {
        public_api_key: this.cartSettings.affirm_public_key,
        script: 'https://cdn1.affirm.com/js/v2/affirm.js'
      };
      const script = document.createElement('script');
      script.id = 'affirm-script';
      script.src = 'https://cdn1.affirm.com/js/v2/affirm.js';
      script.async = true;
      script.onload = () => {
        this.scriptLoaded = true;
        resolve();
      };
    });
  }

  render() {
    if (!this.browser.isBrowser) return;
    const affirm = (window as any).affirm;
    if (affirm && affirm.ui?.refresh) {
      affirm.ui.refresh();
    }
  }
}